import { TRUST_ITEMS } from "@/data/urban";

export const TrustBar = () => (
  <div className="bg-black text-white py-4 sm:py-5">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 grid grid-cols-2 sm:grid-cols-5 gap-3 sm:gap-6 items-center justify-items-center">
      {TRUST_ITEMS.map((t) => (
        <div key={t} className="overline text-white/90 text-center">{t}</div>
      ))}
    </div>
  </div>
);
